export default "/images/vendor/flag-icon-css/flags/4x3/mx.svg?479622e6f02e13aaf2350ca039d2f658";